import { render, staticRenderFns } from "./SchoolModal.vue?vue&type=template&id=51ed93b0&scoped=true&"
import script from "./SchoolModal.vue?vue&type=script&lang=js&"
export * from "./SchoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed93b0",
  null
  
)

export default component.exports